import { render, staticRenderFns } from "./claim-form.vue?vue&type=template&id=3dfcdd32"
import script from "./claim-form.vue?vue&type=script&lang=js"
export * from "./claim-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports